import React from 'react';
import { Building2, Ruler, FlaskConical } from 'lucide-react';
import Container from './Container';
import Button from './Button';
import Reveal from './Reveal';
import { useContactModal } from './ContactModal';

/*
 * CTA band (SPEC §7.2.3 / §7.3.3 / §7.4.3) with a distinct look per page via
 * `variant`: structural (blueprint grid + frame), infrastructure (perspective
 * lines + horizon glow), research (constellation dots). Title/subtitle/button
 * stay data-driven.
 */
const VARIANTS = {
  structural: { icon: Building2, button: 'dark' },
  infrastructure: { icon: Ruler, button: 'accent' },
  research: { icon: FlaskConical, button: 'dark' },
};

export default function CtaBand({ cta, variant = 'structural' }) {
  const { openContact } = useContactModal();
  if (!cta) return null;
  const v = VARIANTS[variant] || VARIANTS.structural;
  const Icon = v.icon;

  return (
    <section className={`cta-band cta-band--${variant}`}>
      <div className="cta-band__decor" aria-hidden="true" />
      <Container>
        <Reveal className="cta-band__inner">
          <span className="cta-band__icon" aria-hidden="true">
            <Icon size={26} />
          </span>
          <h2 className="cta-band__title">{cta.title}</h2>
          <p className="cta-band__subtitle">{cta.subtitle}</p>
          {/* Opens the contact section in a popup (one-to-one with the homepage). */}
          <Button variant={v.button} onClick={openContact} className="cta-band__btn">
            {cta.buttonLabel}
          </Button>
        </Reveal>
      </Container>
    </section>
  );
}
